// utils/dedupeChecklist.js
const RANK = { Severe: 3, Moderate: 2, Light: 1 };          // ✔️ / null / '' === 0

/**
 * Collapse duplicate DropdownValue rows and keep the worst‑case severity.
 * @param {Array<{DropdownValue: string, DamageSeverity: string}>} arr
 * @returns {Array<{DropdownValue, DamageSeverity, DropdownValueId}>}
 */
export function dedupeChecklist(arr = []) {
  const map = new Map();          // key = DropdownValue

  arr.forEach((row) => {
    const key = row.DropdownValue?.trim() || '';
    const incomingRank = RANK[row.DamageSeverity] ?? 0;

    if (!map.has(key)) {
      map.set(key, { ...row });   // first time we see this item
    } else {
      const stored = map.get(key);
      const storedRank = RANK[stored.DamageSeverity] ?? 0;
      if (incomingRank > storedRank) map.set(key, { ...row }); // keep worse icon
    }
  });

  return Array.from(map.values());
}
